import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import { I18nextProvider } from 'react-i18next';
import App from './App';
import i18n from './lib/i18n';
import { PostHogProvider } from './providers/PostHogProvider';
import { TelemetryProvider } from './providers/TelemetryProvider';
import './styles/globals.css';
import './styles/animations.css';

const auth0Domain = import.meta.env.VITE_AUTH0_DOMAIN;
const auth0ClientId = import.meta.env.VITE_AUTH0_CLIENT_ID;
const auth0Audience = import.meta.env.VITE_AUTH0_AUDIENCE;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <TelemetryProvider>
      <Auth0Provider
        domain={auth0Domain}
        clientId={auth0ClientId}
        authorizationParams={{
          redirect_uri: window.location.origin,
          audience: auth0Audience,
        }}
      >
        <I18nextProvider i18n={i18n}>
          <PostHogProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </PostHogProvider>
        </I18nextProvider>
      </Auth0Provider>
    </TelemetryProvider>
  </React.StrictMode>
);
